import { v4 as uuid } from "uuid";
import {
  thrillerBookOne,
  thrillerBookTwo,
  thrillerBookThree,
  thrillerBookFour,
  thrillerBookFive,
  thrillerBookSix,
  romanceBookOne,
  romanceBookTwo,
  romanceBookThree,
  romanceBookFour,
  romanceBookFive,
  romanceBookSix,
  dramaBookOne,
  dramaBookTwo,
  dramaBookThree,
  dramaBookFour,
  dramaBookFive,
  dramaBookSix,
  scifiBookOne,
  scifiBookTwo,
  scifiBookThree,
  scifiBookFour,
  scifiBookFive,
  scifiBookSix,
} from "./../../images.js";

export const products = [
  {
    _id: uuid(),
    bookCover: thrillerBookOne,
    bookTitle: "Murder On The Orient Express",
    bookAuthor: "Agatha Christie",
    bookPrice: 249,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Thriller",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: thrillerBookTwo,
    bookTitle: "400 Days",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 149,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Thriller",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: thrillerBookThree,
    bookTitle: "The Murder of Roger Ackroyd",
    bookAuthor: "Agatha Christie",
    bookPrice: 449,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Thriller",
    bookRating: 2,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: thrillerBookFour,
    bookTitle: "One Arranged Murder",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 299,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Thriller",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: thrillerBookFive,
    bookTitle: "The ABC Murders",
    bookAuthor: "Agatha Christie",
    bookPrice: 399,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Thriller",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: thrillerBookSix,
    bookTitle: "And Then There Were None",
    bookAuthor: "Agatha Christie",
    bookPrice: 249,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Thriller",
    bookRating: 2,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: dramaBookOne,
    bookTitle: "The Legend of Suheldev",
    bookAuthor: "Amish Tripathi",
    bookPrice: 449,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Drama",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: dramaBookTwo,
    bookTitle: "Five Point Someone",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 149,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Drama",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: dramaBookThree,
    bookTitle: "The 3 Mistakes Of My Life",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 299,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Drama",
    bookRating: 2,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: dramaBookFour,
    bookTitle: "The White Tiger",
    bookAuthor: "Aravind Adiga",
    bookPrice: 249,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Drama",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: dramaBookFive,
    bookTitle: "One Night At The Call Center",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 199,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Drama",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: dramaBookSix,
    bookTitle: "The Girl Who Knew Too Much",
    bookAuthor: "Vikrant Khanna",
    bookPrice: 399,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Drama",
    bookRating: 2,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: scifiBookOne,
    bookTitle: "Foundation And Empire",
    bookAuthor: "Isaac Asimov",
    bookPrice: 199,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Scifi",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: scifiBookTwo,
    bookTitle: "Beyond Infinity",
    bookAuthor: "Akash Siddharth",
    bookPrice: 149,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Scifi",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: scifiBookThree,
    bookTitle: "Artemis",
    bookAuthor: "Andy Weir",
    bookPrice: 449,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Scifi",
    bookRating: 2,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: scifiBookFour,
    bookTitle: "Dark Matter",
    bookAuthor: "Blake Crouch",
    bookPrice: 299,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Scifi",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: scifiBookFive,
    bookTitle: "A Wrinkle In Time",
    bookAuthor: "Madeleine Lengle",
    bookPrice: 249,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Scifi",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: scifiBookSix,
    bookTitle: "Kid Who Came From Space",
    bookAuthor: "Ross Welford",
    bookPrice: 349,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Scifi",
    bookRating: 2,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: romanceBookOne,
    bookTitle: "Half Girlfriend",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 349,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Romance",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: romanceBookTwo,
    bookTitle: "2 States",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 149,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Romance",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: romanceBookThree,
    bookTitle: "Revolution 2020",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 249,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Romance",
    bookRating: 2,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: romanceBookFour,
    bookTitle: "One Indian Girl",
    bookAuthor: "Chetan Bhagat",
    bookPrice: 199,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Romance",
    bookRating: 4,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: romanceBookFive,
    bookTitle: "The Fault In Our Stars",
    bookAuthor: "John Green",
    bookPrice: 449,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Romance",
    bookRating: 3,
    bookQuantity: 1,
  },
  {
    _id: uuid(),
    bookCover: romanceBookSix,
    bookTitle: "The Perfect Us",
    bookAuthor: "Durjoy Dutta",
    bookPrice: 299,
    actionOne: "Add To Cart",
    actionTwo: "Add To Wishlist",
    categoryName: "Romance",
    bookRating: 2,
    bookQuantity: 1,
  },
];
